<div class="monitor-layout">
    <div class="monitor-container">

        <!-- Unified Header -->
        <div class="unified-header">
            <div class="header-left">
                <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h1 class="page-title">
                    <mat-icon class="title-icon">cloud_upload</mat-icon>
                    Cargar Documentos Externos
                </h1>
            </div>
        </div>

        <!-- Compact Upload Card (Always Visible) -->
        <mat-card class="upload-card-compact">
            <mat-card-content>
                <div class="upload-controls">
                    <!-- Document Type Selector -->
                    <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                        <mat-label>Tipo de Documento</mat-label>
                        <mat-select [(ngModel)]="selectedDocumentType">
                            <mat-option value="INVOICE">Factura</mat-option>
                            <mat-option value="REFERRAL">Remisión</mat-option>
                            <mat-option value="PRE_INVOICE">Pre-Factura</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- Drag & Drop Zone (Compact) - Entire zone is clickable -->
                    <input type="file" #fileInput hidden (change)="onFileSelected($event)" multiple accept="*/*">
                    <div class="drop-zone-compact" [class.active]="isDragging()" (click)="fileInput.click()"
                        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                        <mat-icon class="drop-icon-small">cloud_upload</mat-icon>
                        <span class="drop-text-small">Arrastra archivos aquí o haz clic para seleccionar</span>
                    </div>

                    <!-- Progress Bar (if uploading) -->
                    @if (uploadProgress()) {
                    <div class="upload-progress-compact">
                        <span class="progress-text-small">
                            {{ uploadProgress()!.processed }}/{{ uploadProgress()!.total }} - {{
                            uploadProgress()!.currentFolio }}
                        </span>
                        <mat-progress-bar mode="determinate"
                            [value]="(uploadProgress()!.processed / uploadProgress()!.total) * 100">
                        </mat-progress-bar>
                    </div>
                    }
                </div>
            </mat-card-content>
        </mat-card>

        <!-- Filters Panel -->
        @if (allGroupsSignal().length > 0) {
        <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <mat-icon>filter_list</mat-icon>
                        <span>Filtros</span>
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    {{ filteredGroupsSignal().length }} folios
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="filtros-form-compact">
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Buscar por Folio</mat-label>
                    <input matInput [formControl]="folioFilterCtrl">
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>

                <div class="filter-actions">
                    <button mat-icon-button color="primary" (click)="clearAll()" type="button"
                        matTooltip="Limpiar Todo">
                        <mat-icon>delete_sweep</mat-icon>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>
        }

        <!-- Top Controls with Paginator and Upload Button -->
        <div class="controles-superiores">
            <span class="info-text">{{ filteredGroupsSignal().length }} folios ({{ totalFilesSignal() }}
                archivos)</span>

            <span class="spacer"></span>

            <!-- Upload Button (moved here per user request) -->
            <!-- Upload Button (moved here per user request) -->
            <button mat-raised-button color="primary" (click)="uploadFiles()"
                [disabled]="isUploading() || allGroupsSignal().length === 0 || !selectedDocumentType">
                @if (!isUploading()) {
                <ng-container>
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Subir y Registrar</span>
                </ng-container>
                } @else {
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                }
            </button>

            @if (filteredGroupsSignal().length > 0) {
            <mat-paginator [length]="filteredGroupsSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
                [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
            </mat-paginator>
            }
        </div>

        <!-- Folio Groups Accordion -->
        @if (paginatedGroupsSignal().length > 0) {
        <mat-accordion [multi]="false" class="folios-accordion">
            @for (group of paginatedGroupsSignal(); track group.folio) {

            @let status = uploadProgress()?.folioStatuses?.get(group.folio) || 'pending';

            <mat-expansion-panel [disabled]="status === 'uploading'">
                <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title-container">
                        <!-- Status Indicator -->
                        <!-- Status Indicator -->
                        <div class="folio-status-indicator">
                            @switch (status) {
                            @case ('pending') {
                            <mat-icon class="status-icon pending" matTooltip="En espera">hourglass_empty</mat-icon>
                            }
                            @case ('uploading') {
                            <mat-icon class="status-icon uploading">cloud_upload</mat-icon>
                            }
                            @case ('success') {
                            <mat-icon class="status-icon success">check_circle</mat-icon>
                            }
                            @case ('error') {
                            <mat-icon class="status-icon error">error</mat-icon>
                            }
                            }
                        </div>

                        <div class="folio-info-group">
                            <div class="info-item">
                                <span class="info-label">Folio:</span>
                                <span class="info-value folio">{{ group.folio }}</span>
                            </div>
                            @if (status === 'uploading') {
                            <span class="uploading-text">Subiendo archivos...</span>
                            }
                            <div class="info-item">
                                <span class="info-label">Archivos:</span>
                                <span class="info-value">{{ group.files.length }}</span>
                            </div>
                        </div>

                        <div class="folio-info-group align-right">
                            <div class="info-item">
                                <span class="info-label">Tamaño Total:</span>
                                <span class="info-value">{{ (group.totalSize / 1024).toFixed(2) }} KB</span>
                            </div>
                        </div>

                        <div class="folio-actions">
                            <button mat-icon-button color="warn"
                                (click)="removeFolio(group.folio); $event.stopPropagation()"
                                matTooltip="Quitar de la lista" [disabled]="status === 'uploading'">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </mat-panel-title>

                    @if (status === 'uploading') {
                    <mat-progress-bar mode="indeterminate" class="item-progress-bar"></mat-progress-bar>
                    }
                </mat-expansion-panel-header>

                <!-- Files as horizontal cards -->
                <div class="files-container">
                    <div class="files-scroll-container">
                        @for (file of group.files; track $index) {
                        <div class="file-card">
                            <div class="file-card-header">
                                <mat-icon class="file-icon"
                                    [class.pdf-icon]="getFileIcon(file.name) === 'picture_as_pdf'"
                                    [class.image-icon]="getFileIcon(file.name) === 'image'"
                                    [class.excel-icon]="getFileIcon(file.name) === 'table_chart'">
                                    {{ getFileIcon(file.name) }}
                                </mat-icon>
                                <span class="file-type-badge">{{ getFileType(file.name) }}</span>
                            </div>
                            <div class="file-card-body">
                                <div class="file-card-name">{{ file.name }}</div>
                                <div class="file-card-size">{{ (file.size / 1024).toFixed(2) }} KB</div>
                            </div>
                            <button mat-icon-button class="file-delete-btn" color="warn"
                                (click)="removeFile(group.folio, $index)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
        } @else if (allGroupsSignal().length === 0) {
        <div class="no-files">
            <mat-icon>inbox</mat-icon>
            <p>No hay archivos seleccionados. Arrastra archivos o usa el botón "Seleccionar".</p>
        </div>
        } @else {
        <div class="no-files">
            <mat-icon>search_off</mat-icon>
            <p>No se encontraron folios con el filtro aplicado.</p>
        </div>
        }

        <!-- Bottom Paginator -->
        @if (filteredGroupsSignal().length > pageSize()) {
        <div class="bottom-paginator">
            <mat-paginator [length]="filteredGroupsSignal().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
                [pageSizeOptions]="[10, 20, 50]" (page)="handlePageEvent($event)" showFirstLastButtons>
            </mat-paginator>
        </div>
        }
    </div>
</div>